import * as actionTypes from './allActionList';
import axios from '../../config/axios-config';

const returnSetLanguage = (lang) => {
  return {
    type: actionTypes.SET_LANGUAGE,
    lang,
  };
};

export const setLanguage = (lang) => {
  return (dispatch) => {
    if (
      !localStorage.getItem('intereact-locale') ||
      localStorage.getItem('intereact-locale') !== lang
    ) {
      localStorage.setItem('intereact-locale', lang);
      return dispatch(returnSetLanguage(lang));
    }

    dispatch(returnSetLanguage(localStorage.getItem('intereact-locale')));
  };
};

export const checkStoredLanguage = () => {
  return (dispatch) => {
    if (localStorage.getItem('intereact-locale')) {
      dispatch(returnSetLanguage(localStorage.getItem('intereact-locale')));
    }
  };
};

const setGtranslateToUnavaialabe = () => {
  return {
    type: actionTypes.SET_GTRANSLATE_TO_UNAVAILABLE,
  };
};

export const checkGoogleTranslateStatus = () => {
  return async (dispatch) => {
    try {
      const { data } = await axios.post('/intereact/google-translate/auto', {
        q: 'trial',
        target: 'it',
      });

      if (data.statusCode === 403) throw new Error();
    } catch (e) {
      dispatch(setGtranslateToUnavaialabe());
    }
  };
};
